export default Object.freeze({
  CreditCard: 1,
  Email: 2,
  Phone: 3,
  IpAddress: 5,
  IbanCode: 6,
  Url: 8,
  UsBankNumber: 1000,
  UsItin: 1002,
  UsPassport: 1003,
  UsSsn: 1004,
  PeDni: 2000,
  PeRuc: 2001,
  PePassport: 2002,
  PeBankAccountNumber: 2003,
  PeBankAccountCci: 2004,
});
